
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import voucherMixin from '@marketplace/mixins/voucherMixin.js'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalWelcome',

    components: {
        ModalEducateUsers,
    },
    mixins: [voucherMixin],

    props: {
        voucherData: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            steps: [],
        }
    },

    computed: {
        ...mapGetters('global', ['globalFreeShippingAmount']),
    },

    created() {
        const initialSteps = [
            {
                title: `${this.$t('labels.hi_name', [
                    this.$store.state.global.account.userFirstName,
                ])}<br>${this.$t('labels.welcome_to_orderchamp')}`,
                description: this.$t('modal.welcome.description'),
                backgroundColor: '#42594f',
                imageUrl:
                    require('~assets/images/user-education/onboarding-modal-image-01.svg'),
            },
            {
                title: this.$t('labels_welcome_title_terms'),
                description: this.$t('labels_welcome_description_intro'),
                backgroundColor: '#984F35',
                imageUrl:
                    require('~assets/images/user-education/onboarding-modal-image-02.svg'),
                extraContent: this.getExtraContent(),
            },
            {
                title: this.$t('labels.here_to_support'),
                description: this.$t('labels.support.description'),
                backgroundColor: '#DDB254',
                imageUrl:
                    require('~assets/images/user-education/onboarding-modal-image-03.svg'),
            },
        ]
        if (this.voucherData && Object.keys(this.voucherData).length > 0) {
            const voucherStep = this.createVoucherStep(this.voucherData)
            if (voucherStep) {
                initialSteps.push(voucherStep)
            }
        }
        this.steps = initialSteps.filter(Boolean)
    },

    methods: {
        getExtraContent() {
            const extraContent = [
                {
                    iconClass: 'far fa-check-circle text-success',
                    text: this.$t('labels.lowest_order_minimums'),
                },
                {
                    iconClass: 'far fa-check-circle text-success',
                    text: this.$t('homepage.ups.short.usp2.title'),
                },
            ]
            if (this.globalFreeShippingAmount) {
                extraContent.unshift({
                    iconClass: 'far fa-check-circle text-success',
                    text: this.$t(
                        'storefront.attribute.freeshipping_with_currency',
                        [
                            this.$n(
                                this.globalFreeShippingAmount,
                                'currency-no-decimal'
                            ),
                        ]
                    ),
                })
            }
            return extraContent
        },
    },
}
